import { render, staticRenderFns } from "./commonIndex.vue?vue&type=template&id=62b5e783&scoped=true&"
import script from "./commonIndex.vue?vue&type=script&lang=js&"
export * from "./commonIndex.vue?vue&type=script&lang=js&"
import style0 from "./commonIndex.vue?vue&type=style&index=0&id=62b5e783&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b5e783",
  null
  
)

export default component.exports